export const required = value => (!value ? 'Required' : null);